import { CLIENT } from 'core/variables/constant';

/**
 * Which AI mascot artwork a tenant shows. The chatbot only ever reads the `--tangerine-ai-bot-*`
 * CSS variables (declared on `:root` in `public/css/styles.css`); a theme other than the default
 * is applied as an attribute on `<html>` so the stylesheet's `:root[data-ai-mascot]` block wins,
 * including inside portaled dialogs and the chat panel, which render outside `.app-content`.
 */
export const AI_MASCOT_THEMES = {
  TANGERINE: 'tangerine',
  SUMUN: 'sumun',
} as const;

export type AiMascotTheme = (typeof AI_MASCOT_THEMES)[keyof typeof AI_MASCOT_THEMES];

export const AI_MASCOT_ATTRIBUTE = 'data-ai-mascot';

const SUMUN_MASCOT_CLIENTS: ReadonlySet<string> = new Set([CLIENT.SUMUN_CHILE, CLIENT.SUMUN_CAMPUS_BRASIL, CLIENT.SUMUN_MX]);

export function getAiMascotTheme(client: string | null | undefined): AiMascotTheme {
  const hasSumunMascot = SUMUN_MASCOT_CLIENTS.has(client ?? '');

  return hasSumunMascot ? AI_MASCOT_THEMES.SUMUN : AI_MASCOT_THEMES.TANGERINE;
}

/** The default theme leaves the root unmarked so the base stylesheet declarations apply untouched. */
export function applyAiMascotTheme(theme: AiMascotTheme): void {
  if (theme === AI_MASCOT_THEMES.TANGERINE) {
    document.documentElement.removeAttribute(AI_MASCOT_ATTRIBUTE);
    return;
  }
  document.documentElement.setAttribute(AI_MASCOT_ATTRIBUTE, theme);
}
